<template>
  <v-card class="mt-3 rounded-card">
    <v-card-title class="font-weight-bold">
      Produtos
    </v-card-title>
    <v-card-text class="text--primary">
      <v-row dense>
        <v-col cols="12" v-if="isMoedaEstrangeira">
          <px-moeda-chip :moeda="moeda"/>
        </v-col>
        <v-col cols="12" sm="4">
          <template v-if="isMoedaEstrangeira">
            <v-row dense no-gutters class="body-1">
              <v-col cols="6">
                Produtos:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  aprovacao.totalProdutos |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6">
                Frete:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  aprovacao.frete.totalTransporte |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6" class="font-weight-bold">
                Total:
              </v-col>
              <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{
                      aprovacao.total |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </span>
              </v-col>
              <template v-if="isMoedaEstrangeira && aprovacao.saving">
                <v-col cols="6" class="font-weight-bold">
                  Saving:
                </v-col>
                <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{
                          aprovacao.saving |
                            currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                        }}
                      </span>
                </v-col>
              </template>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="4"></v-col>
        <v-col cols="12" sm="4">
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ aprovacao.valorMoedaConvertido.totalProdutos
                | currency(simboloMoeda, casaDecimal) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ aprovacao.frete.totalTransporteConvertido | currency }}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{ aprovacao.valorMoedaConvertido.total
                      | currency(simboloMoeda, casaDecimal) }}
                  </span>
            </v-col>
            <template v-if="aprovacao.saving">
              <v-col cols="6" class="font-weight-bold">
                Saving:
              </v-col>
              <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{ aprovacao.valorMoedaConvertido.saving
                         | currency(simboloMoeda, casaDecimal) }}
                      </span>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        show-expand
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="aprovacao.produtos"
        item-key="id"
        class="elevation-0 mt-3"
      >
        <template v-slot:item.descricao="{ item }">
          <px-span-tooltip v-if="checkCodigo(item.produto)"
                    top
                    :text="labelCodigo(item.produto)"
                    tooltip="Código interno"/>
          {{ item.produto.descricao }}&nbsp;
          <px-resumo-produto-dialog :produto="item.produto"
                                    :unidade-medida="item.unidadeMedida"/>
          <px-anexo v-if="item.arquivos && item.arquivos.length"
                    small read-only dot
                    v-model="item.arquivos"
                    download-base-path="files/download-comprador">
            <template v-slot:activator="{ on }">
              <v-btn small icon
                     v-on="on">
                <v-icon small>mdi-paperclip</v-icon>
              </v-btn>
            </template>
          </px-anexo>
        </template>
        <template v-slot:item.quantidade="{ item }">
          <span>
            {{ item.quantidade | number(getCurrencyFormat(item.produto.casasDecimais)) }}&nbsp;
          {{ item.unidadeMedida.descricao }}
          </span>
        </template>
        <template v-slot:item.precoUnitario="{ item }">
          <div>
            {{
              item.valorMoedaConvertido.precoUnitario
                | currency('R$', item.produto.casasDecimais)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.precoUnitario
                  | currency(simboloMoeda,
                  item.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
        </template>
        <template v-slot:item.icms="{ item }">
          <px-imposto
            :imposto="item.impostos"
            show-valor-convertido
            tipo="ICMS"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              :imposto="item.impostos"
              :simbolo-moeda="simboloMoeda"
              :configuracao-moeda="configuracaoFormatacaoMoeda"
              tipo="ICMS"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.ipi="{ item }">
          <px-imposto
            show-valor-convertido
            :imposto="item.impostos"
            tipo="IPI"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              :imposto="item.impostos"
              :simbolo-moeda="simboloMoeda"
              :configuracao-moeda="configuracaoFormatacaoMoeda"
              tipo="IPI"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          <div>
            {{ item.valorMoedaConvertido.total | currency('R$', item.produto.casasDecimais) }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.total
                  | currency(simboloMoeda,
                  item.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
          <px-situacao-cotacao-produto :situacao="item.situacao"/>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="grey lighten-4 expanded-item">
            <v-row class="mt-3" dense>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observação externa do produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoExterna(item)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observação Interna do produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoInterna(item)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">{{ labelEspecificacaoProduto }}</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProduto"/>
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Data de faturamento</span>
                <div>
                  {{ item.dataFaturamento | date | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Prazo de entrega</span>
                <div>
                  {{ item.dataPrevisaoEntrega | date }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Finalidade da compra</span>
                <div v-if="item.finalidadeCompra">
                  <px-finalidade-compra-value :finalidade-compra="item.finalidadeCompra"/>
                </div>
                <div v-else>
                  Não informado
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-3" dense>
              <v-col cols="12" sm="4" v-if="isFromCotacao">
                <span class="caption font-weight-bold">Especificação cotada</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProdutoOrigem"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.centroCusto">
                <span class="caption font-weight-bold">Centro de custo</span>
                <div>
                  {{ centroCusto(item.centroCusto) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.projeto">
                <span class="caption font-weight-bold">Projeto</span>
                <div>
                  {{ projeto(item.projeto) }}
                </div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4" v-if="item.tipoNotaEntrada">
                <span class="caption font-weight-bold">Tipo de nota de entrada do produto</span>
                <div>
                  <px-span-tooltip top
                      :text="notaEntrada(item.tipoNotaEntrada)"
                      :tooltip="item.tipoNotaEntrada.descricao"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.cfop">
                <span class="caption font-weight-bold">CFOP do produto</span>
                <div>
                  <px-span-tooltip top
                      :text="cfop(item.cfop)"
                      :tooltip="`${item.cfop.codigo} - ${item.cfop.descricao}`"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="checkPrecoTarget(item)">
                <span class="caption font-weight-bold">Preço target</span>
                <div>
                  {{ item.produto.precoTarget | currency('R$', getCasaDecimalItem(item.produto)) }}
                </div>
              </v-col>
            </v-row>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import { OrigemCompra } from 'px-business-components';
import { CasaDecimalUtils } from 'px-components';
import { descWithCodigoInterno } from '@/utils/object-utils';
import moedaMixin from '@/mixins/moeda-mixin';
import { getPrecision } from '@/utils/produto-utils';

export default {
  mixins: [moedaMixin],
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'ICMS',
          value: 'icms',
          sortable: false,
        },
        {
          text: 'IPI',
          value: 'ipi',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: '',
          value: 'options',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    moeda() {
      return this.aprovacao.moeda;
    },
    isFromCotacao() {
      return this.aprovacao.origemCompra === OrigemCompra.keys.COTACAO.key;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casaDecimal() {
      const mappedProdutos = this.aprovacao.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `${item.codigo} -`;
    },
    cfop() {
      return cfop => `${cfop.codigo} - ${Vue.filter('truncate')(cfop.descricao, 20)}`;
    },
    notaEntrada() {
      return notaEntrada => Vue.filter('truncate')(notaEntrada.descricao, 20);
    },
    getCasaDecimalItem() {
      return produto => getPrecision(produto);
    },
    observacaoInterna() {
      return (produto) => {
        if (produto.observacaoInterna) {
          return produto.observacaoInterna;
        }
        return produto.produto.observacaoInterna;
      };
    },
    observacaoExterna() {
      return (produto) => {
        if (produto.observacaoExterna) {
          return produto.observacaoExterna;
        }
        return produto.produto.observacaoExterna;
      };
    },
    labelEspecificacaoProduto() {
      return this.isFromCotacao ? 'Especificação do fornecedor' : 'Especificação do produto';
    },
    projeto() {
      return projeto => descWithCodigoInterno(projeto);
    },
    centroCusto() {
      return centroCusto => descWithCodigoInterno(centroCusto);
    },
    checkPrecoTarget() {
      return item => item.produto.precoTarget && item.produto.precoTarget > 0;
    },
  },
};
</script>
